export default "__VITE_ASSET__D3G7whSU__"